import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/objetivo/importer/objetivoImporterActions';

export default importerReducers(actions);
